import React, { useState, useEffect, useCallback } from "react";
import io from "socket.io-client";
import axios from "axios";

import Card from "react-bootstrap/Card";

//import AcUnitIcon from "@mui/icons-material/AcUnit";
//import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import PauseIcon from "@mui/icons-material/Pause";

//import TempScale from "./DeviceCircularChart";
import HistoryGraph from "../HistoryGraph/HistoryGraph";
import Gauge from "./Gauge";

//redux setup
import { useDispatch } from "react-redux";
import { setNotifications, setAlarmNotifications } from "Store/home";

import "./Device.css";
//import { columnDropStyleBordered } from "ag-grid-community";

interface props {
	device: any;
	state: string;
	graph: boolean;
	show: boolean;
	myGraph: boolean;
	page: string;
}

//socket
const socket = io(
	`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SOCKET_HOST}:${process.env.REACT_APP_SOCKET_PORT}`
);

const Device: React.FC<props> = ({
	device,
	state,
	graph,
	show,
	myGraph,
	page,
}) => {
	const dispatch = useDispatch();
	const [colorScheme, setColorScheme] = useState("");

	const [deviceData, setDeviceData] = useState(device);

	const topic = `/QFLO/${device.client}/${device.site}/${device.building}/${device.area}/${device.deviceId}`;

	//const [dimensions, setDimensions] = useState(0);

	// useEffect(() => {
	// 	//310 - 767px
	// 	console.log(window.innerWidth);
	// 	setDimensions(window.innerWidth);
	// }, []);
	useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			requestAnimationFrame(() => {
				for (let entry of entries) {
					// safely trigger any updates
					// avoid state changes directly in this block if possible
				}
			});
		});

		observer.observe(document.body); // or any element
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		setDeviceData(device);
	}, [device]);

	useEffect(() => {
		socket.emit("subscribeTopic", topic);

		const handleMqttData = (message: any) => {
			//console.log(message);
			setDeviceData(message);
			let type = "";
			let desc = "";

			const handleNotification = (notificationType: string) => {
				if (type.length > 0 && desc.length > 0) {
					message.name = device.name;
					let date = new Date()
						.toString()
						.replace(" GMT+0200 (South Africa Standard Time)", "");
					let filterDate = new Date().getTime();
					message.date = date.substring(3, date.length - 3);
					message.filterDate = filterDate;
					message.type = type;
					message.desc = desc;
					notificationType === "notification"
						? dispatch(setNotifications(message))
						: dispatch(setAlarmNotifications(message));
				}
			};

			if (!message.powerOn) {
				type = "Power";
				desc = `Offline`;
				handleNotification("alarm");
			} else if (message.coolerOn) {
				type = "Cooling";
				desc = `Cooling`;
				handleNotification("notification");
			} else if (message.heaterOn) {
				type = "Heating";
				desc = `Heating`;
				handleNotification("notification");
			} else if (
				message.tempVal >
				message.tempSet + message.tempDiff + message.tempDiff
			) {
				type = "Too Hot";
				desc = `Temp: ${message.tempVal}, target: ${message.tempSet}`;
				handleNotification("alarm");
			} else if (
				message.tempVal <
				message.tempSet - message.tempDiff - message.tempDiff
			) {
				type = "Too Cold";
				desc = `Temp: ${message.tempVal}, target: ${message.tempSet}`;
				handleNotification("alarm");
			} else {
				type = "Idle";
				desc = `Temp: ${message.tempVal}`;
				handleNotification("notification");
			}
		};

		socket.off(topic, handleMqttData);
		socket.on(topic, handleMqttData);

		return () => {
			socket.off(topic, handleMqttData);
		};
	}, [device.name, dispatch, topic]);

	useEffect(() => {
		const colorScheme = (data: any) => {
			if (data.tempVal > data.tempSet + data.tempDiff) {
				setColorScheme("device-temp-hot");
			} else if (data.tempVal < data.tempSet - data.tempDiff) {
				setColorScheme("device-temp-cold");
			} else {
				setColorScheme("device-temp-neutral");
			}
		};

		colorScheme(deviceData);
	}, [deviceData, device]);

	const [devicePower, setDevicePower] = useState(true);

	useEffect(() => {
		if (!deviceData.powerOn) {
			setDevicePower(false);
		}
		//console.log(deviceData.powerOn);
	}, [deviceData.powerOn]);

	const tempIcon = () => {
		if (!deviceData.powerOn) {
			return <PowerSettingsNewIcon />;
		} else if (deviceData.coolerOn) {
			return (
				<img
					className="device-temp-cold device-icon-position"
					src="/media/icons/cooling.png"
					alt="cooling"
				/>
			);
		} else if (deviceData.heaterOn) {
			return (
				<img
					src="/media/icons/heating.png"
					alt="heating"
					className="device-temp-hot"
				/>
			);
		}
	};

	const serverUrl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SERVER_HOST}:${process.env.REACT_APP_SERVER_HOST_PORT}`;

	const [highLowSymbol, setHighLowSymbol] = useState<any>("");

	const fetchData = useCallback(
		(
			deviceId: any,
			agg: number,
			type: string,
			startDate: any,
			endDate: any
		) => {
			axios
				.post(
					`${serverUrl}/api/device-history`,
					{
						deviceId: deviceId,
						agg: agg,
						type: type,
						startDate: startDate,
						endDate: endDate,
					},
					{
						withCredentials: true,
					}
				)
				.then(async function (response) {
					const apiData = await response.data;

					if (apiData.status === "success") {
						let tempSum: number = 0;
						const apiArrayLength: number = apiData.data.length;
						// console.log(
						// 	"name",
						// 	deviceData.name,
						// 	"deviceId",
						// 	deviceId,
						// 	"length",
						// 	apiArrayLength,
						// 	"array: ",
						// 	apiData.data
						// );
						const tempValue = deviceData.tempVal;
						const iconStyle = { marginLeft: "5px" };
						for (let i = 0; i < apiArrayLength; i++) {
							tempSum += Number(apiData.data[i].tempValue);
						}
						if (tempSum / apiArrayLength > tempValue) {
							setHighLowSymbol(<ArrowDropUpIcon style={iconStyle} />);
						} else if (tempSum / apiArrayLength < tempValue) {
							setHighLowSymbol(<ArrowDropDownIcon style={iconStyle} />);
						} else {
							setHighLowSymbol("");
						}
					}
				})
				.catch(function (error) {
					console.error(error);
				});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[serverUrl]
	);

	useEffect(() => {
		if (!show) {
			fetchData(
				deviceData.deviceId,
				1,
				"5min",
				new Date().toISOString(),
				new Date().toISOString()
			);
		}
		// console.log(deviceData.deviceId);

		const intervalId = setInterval(() => {
			if (!show) {
				fetchData(
					deviceData.deviceId,
					1,
					"5min",
					new Date().toISOString(),
					new Date().toISOString()
				);
			}
		}, 300000);
		return () => {
			clearInterval(intervalId);
		};
	}, [deviceData.deviceId, fetchData, show]);

	return (
		<Card
			style={{
				...(deviceData.powerOn
					? {
							boxShadow:
								"rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
					  }
					: {
							filter: "brightness(0.9)",
							opacity: 1,
					  }),
				...(page === "devicePage"
					? {
							boxShadow: "none",
							border: "none",
							filter: "none",
					  }
					: {}),
			}}
			className={state === device.deviceId ? "device-focus device" : "device"}
		>
			{page !== "devicePage" && (
				<div className="status-div">
					<strong>{device.name}</strong>
					<div className="icon-status">{tempIcon()}</div>
				</div>
			)}
			<div className={show ? "device-temp-div" : "device-temp-div-alt"}>
				{
					show && (
						<Gauge
							device={deviceData}
							myGraph={myGraph}
							page={page}
						/>
					) /*<TempScale device={deviceData} />*/
				}
				<div className="temp-div">
					<div className={`device-temp ${colorScheme}`}>
						{deviceData.tempVal}
					</div>
					{show && highLowSymbol}
				</div>
				{graph ? (
					<div
						style={{
							backgroundColor: "#000000",
							color: "#ffffff",
							padding: 0,
							fontSize: "8px",
						}}
					>
						<span>1 Hour</span>
						<HistoryGraph
							interval={true}
							//clientId={device.client}
							deviceId={device.deviceId}
							agg={1}
							type="hour"
							height={30}
							tools={false}
							filter={false}
							leftMargin={false}
						/>
						<span>24 Hours</span>
						<HistoryGraph
							interval={true}
							//clientId={device.client}
							deviceId={device.deviceId}
							agg={1}
							type="24hour"
							height={30}
							tools={false}
							filter={false}
							leftMargin={false}
						/>
					</div>
				) : null}
			</div>
		</Card>
	);
};

export default Device;
